import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Card, CardContent, Checkbox, FormControlLabel, Button , Radio, RadioGroup } from "@mui/material";
import './style.css'
import "../style.css"
import anmolLogo from "../../assets/images/anmol_logo_transparent.png"
import { ToastContainer, toast } from "react-toastify";
import { fetchAllVendors } from "assets/globalAPI/apiGlobal";

export default function VendorBusinessType() {
  const toastId= React.useRef(null)
   const [selectedOption, setSelectedOption] = useState("");
   const [selectedCard, setSelectedCard] = useState("others"); 
  const [msme, setMsme] = useState(false);
  const [fssi, setFssi] = useState(false);
  const [others, setOthers] = useState(false);
  const [noSelected, setNoSelected]= useState("");
  const [vendorArr,setVendorArr]= useState([]);
  const navigate = useNavigate();

  // Load values from localStorage when the component mounts
 

  // Update localStorage when state changes

  const fetchVendors=async()=>{
         
          let body;
          body={
            page:1,
            reference_id: localStorage.getItem("refId"),
          }
          
          try{
            const response= await fetchAllVendors(body);
            const res= response.data;
            if(res.status){
              console.log("Vendors fetched>> ", res);
              setVendorArr(res.data);
              if(res.data.length>0 || res.data.length!==undefined || res.data!==null){
               navigate("/vendor/registration-form")

              }
              
            }else{
              console.log("Could not fetch vendors>> ", res);
              setVendorArr([]);
            }
          }catch(err){
            console.log("Error bringing vendors>> ", err);
            if(err.response?.status==403){
              if(!toast.isActive(toastId.current)){
                toastId.current= toast.error(err.response.data.message,{
                  className:"small-toast"
                })
              }
              setTimeout(()=>{
                navigate("/")
                localStorage.clear();
              },2000)
            }
          }
        }

  useEffect(()=>{
    fetchVendors()
    const isAuthenticate= localStorage.getItem("isAuthenticated");
    if(!isAuthenticate || isAuthenticate!=="true"){
      navigate("/vendor/validation");
    }
  },[])

  const handleMsmeChange=(e)=>{
    setMsme(e.target.checked);
  }
  const handleFssiChange=(e)=>{
    setFssi(e.target.checked)
  }

  const handleCardSelection = (card) => {
    setSelectedCard(card);
    if (card === "others") {
      setMsme(false);
      setFssi(false);
      setOthers(true)
    }
  };
 

  const handleProceed = () => {
      if(selectedCard===""){
        if(!toast.isActive(toastId.current)){
          toastId.current= toast.warning("Please select a business type",{
                    className: "small-toast"
                  })
        }
        return;
      }else if(selectedCard==="business"){
        if(!msme && !fssi){
          if(!toast.isActive(toastId.current)){
            toastId.current= toast.warning("Please select any one or both of the types",{
                      className: "small-toast"
                    })
          }
          return;
        }else{
          localStorage.setItem("msme",msme);
          localStorage.setItem("fssi",fssi);
          navigate("/vendor/registration-form")
          return;
        }
      }else{
        localStorage.setItem("msme",msme);
        localStorage.setItem("fssi",fssi);
        navigate("/vendor/registration-form")
      }
  };

  return (
    <>
    <ToastContainer/>
    <div className="container">
    <div className="image-container">
      <img src={anmolLogo} alt="Business Image" className="business-image" />
    </div>

    <h2 className="title">Is Your Business:</h2>

    <div className="checkbox-cards-container">
      {/* First Card: Business Registrations */}
      {/* <div className={`checkbox-card ${selectedCard === "business" ? "active" : ""}`}>
        <FormControlLabel
          control={
            <Radio
              sx={{ color: "#01040a" }}
              checked={selectedCard === "business"}
              onChange={() => handleCardSelection("business")}
            />
          }
        />
        <div className="checkbox-options">
          <FormControlLabel
            control={<Checkbox disabled={selectedCard!=="business"} sx={{ color: "#01040a" }} checked={msme} onChange={handleMsmeChange} />}
            label={<span className="checkbox-label">MSME Registered</span>}
          />
          <FormControlLabel
            control={<Checkbox disabled={selectedCard!=="business"} sx={{ color: "#01040a" }} checked={fssi} onChange={handleFssiChange} />}
            label={<span className="checkbox-label">FSSAI Registered</span>}
          />
        </div>
      </div> */}

      {/* Second Card: Others */}
      <div className={`checkbox-card ${selectedCard === "others" ? "active" : ""}`}>
        <FormControlLabel
          control={
            <Radio
            // disabled={selectedCard==="business"}
              sx={{ color: "#01040a" }}
              checked={selectedCard === "others"}
              onChange={() => handleCardSelection("others")}
            />
          }
          label={<span className="checkbox-label">Others</span>}
        />
      </div>
    </div>

    <Button variant="contained" sx={{ color: "ivory", marginTop: "30px" }} onClick={handleProceed} color="primary" className="proceed-button">
      Proceed
    </Button>
  </div>
    </>
  
  );
}
